import { createContext, useContext } from 'react';
import { useUrlCrypto } from 'hooks/useUrlCrypto';

const UrlCryptoCtx = createContext(null);

export function UrlCryptoProvider({ children }) {
  const passphrase =
    process.env.REACT_APP_WIRE24_PUBLIC_URL_SECRET || 'fallback-secret';
  if (!passphrase)
    throw new Error('REACT_APP_WIRE24_PUBLIC_URL_SECRET is not set.');
  const api = useUrlCrypto(passphrase);
  return <UrlCryptoCtx.Provider value={api}>{children}</UrlCryptoCtx.Provider>;
}

export function useAppUrlCrypto() {
  const ctx = useContext(UrlCryptoCtx);
  if (!ctx)
    throw new Error('useAppUrlCrypto must be used within UrlCryptoProvider');
  return ctx;
}
